/**
 * Router Configuration
 * Defines the routing structure for the HKPN application.
 * Uses lazy loading for better performance by splitting the code into chunks.
 */

import { createRouter, createWebHistory } from 'vue-router'

/**
 * Lazy-loaded component imports
 * Components are loaded only when their routes are accessed
 */
const
  News = () => import('@/views/News.vue'),
  About = () => import('@/views/About.vue'),
  Vejledning = () => import('@/components/about/Vejledning.vue'),
  CookiePolitik = () => import('@/components/about/CookiePolitik.vue'),
  Persondata = () => import('@/components/about/Persondata.vue'),
  Feedback = () => import('@/views/Feedback.vue'),
  MapSearch = () => import('@/views/MapSearch.vue'),
  DocumentSearch = () => import('@/views/DocumentSearch.vue')

/**
 * Route definitions
 * Each route object defines:
 * - path: URL path
 * - name: Route identifier
 * - component(s): Vue component to render
 * - meta: Additional route metadata
 */
const routes = [
  {
    path: '/kort',
    name: 'MapSearch',
    alias: ['/', '/home'], // Map search is the default landing page
    components: {
      default: MapSearch
    }
  },
  {
    path: '/dokumenter',
    name: 'DocumentSearch',
    components: {
      default: DocumentSearch
    }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: Feedback
  },
  {
    path: '/nyheder',
    name: 'News',
    component: News
  },
  {
    path: '/om',
    name: 'About',
    component: About
  },
  {
    path: '/cookies',
    name: 'CookiePolitik',
    component: CookiePolitik,
    meta: {
      textColor: 'black',
      domain: 'historiskekort.dk'
    }
  },
  {
    path: '/persondata',
    name: 'Persondata',
    component: Persondata,
    meta: {
      textColor: 'black',
      domain: 'historiskekort.dk'
    }
  },
  {
    path: '/vejledning',
    name: 'Vejledning',
    component: Vejledning,
    meta: {
      textColor: 'black',
      domain: 'historiskekort.dk'
    }
  },
  {
    path: '/was',
    beforeEnter () {
      // Redirect to external accessibility statement
      location.href = 'https://www.was.digst.dk/historiskekort-dk'
    },
    name: 'Webtilgaengelighed',
    meta: {
      textColor: 'black',
      domain: 'historiskekort.dk'
    }
  }
]

/**
 * Router instance configuration
 * Uses HTML5 History mode for clean URLs without hash
 */
const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
